
<wc-grid gridKey="fracSyncs" (onEdit)="onEdit($event)" (onCreate)="onAdd()" />

